export default __webpack_public_path__ + "static/media/the_best.a03d5896.png";